import * as tslib_1 from "tslib";
import settingsAccount from "@/widgets/settingsAccount.vue";
import settingsProfiles from "@/widgets/settingsProfiles.vue";
import settingsEditDeleteAccount from "@/widgets/settingsEditDeleteAccount.vue";
import { Vue, Component } from "vue-property-decorator";
let widget = class widget extends Vue {
};
widget = tslib_1.__decorate([
    Component({
        components: {
            "settings-account": settingsAccount,
            "settings-profiles": settingsProfiles,
            "settings-edit-delete-account": settingsEditDeleteAccount
        }
    })
], widget);
export default widget;
